import { useMemo } from 'react';

/**
 * Shared hook for computing gallery grid style from settings.
 * Used by BoldTemplate, CleanTemplate, CreativeTemplate, and PopTemplate.
 */
export default function useGalleryConfig(settings) {
  const gridConfig = settings?.gallery_grid_config;

  const galleryGridStyle = useMemo(() => {
    if (!gridConfig) return {};
    return {
      display: 'grid',
      gridTemplateColumns: gridConfig.columnWidths.map((w) => `${w}%`).join(' '),
      gridAutoRows: `${gridConfig.rowHeight}px`,
      gap: `${gridConfig.gap}px`,
    };
  }, [gridConfig]);

  return { gridConfig, galleryGridStyle };
}
